import blog1 from "../../assets/images/meeting-with-client-for-gathering-requirements.webp";
import blog2 from "../../assets/images/brainstorming-the-best-software-solutions.webp";
import blog3 from "../../assets/images/website-designers-discussing-low-fidelity-mockups.webp";
import blog4 from "../../assets/images/coding-on-a-computer.webp";
import blog5 from "../../assets/images/software-testing.webp";

export const process = [
  {
    title: "Discovery & Requirements Gathering",
    image: blog1,
    description:
      "We listen first and listen well, making sure you’re heard and understood before being presented with a solution for your vision and goals. ",
  },
  {
    title: "Ideation  & Planning",
    image: blog2,
    description:
      "Our experts brainstorm the smartest technical solution to your requirements and present the actionable software architecture and workflows.",
  },
  {
    title: "Design & prototyping",
    image: blog3,
    description:
      "Aesthetically pleasing mockups for the software’s user-interface are presented which are further elaborated by interactive prototyping to demonstrate the software’s functionality and user-experience. ",
  },
  {
    title: "Development & testing",
    image: blog4,
    description:
      "Our in-house team of specialists executes the full-stack coding of software, while ensuring top-notch quality assurance protocols at each stage.  ",
  },
  {
    title: "Deployement & Maintenance",
    image: blog5,
    description:
      "From hassle-free launch to consistent support and upgrades, we’ve got you covered.  ",
  },
];
export const faqData = [
  {
    id: "01",
    question: "What is our usual project size and what industries does Apptalyst serve? ",
    answer:
      "The Apptalyst team loves designing logos and promotional graphics, like flyers, for small businesses and individuals. We also serve enterprises with intricately tailored materials and promotional content following their brand guidelines and branding goals.",
  },
  {
    id: "02",
    question:
      " How much do our design services cost? ",
    answer:
      "Our hourly rates are as low as $20 per hour, but we request communication of your exact requirements so we can offer the suitable package for your needs.",
  },

  {
    id: "03",
    question: "How long does a design take to be completed?",
    answer:
      "The timelines for completion are based entirely on the complexity and number of revisions requested, but a basic graphic design task can be delivered on the same day as well if required urgently. UI/UX design projects can take anywhere between 1-8 weeks to be completed.",
  },

  {
    id: "04",
    question: "How do I know which services or packages suit my needs? ",
    answer:
      "In case you're having difficulties in determining which services or packages suit your needs, get in touch with us with the details. We will carefully evaluate your requirements and concepts to guide you on all aspects and help you decide which services you're particularly looking for to achieve your goals. ",
  },

  {
    id: "05",
    question: "How does our process work and how many revisions do we offer?",
    answer:
      " We begin with a discovery call or meeting where we gather the necessary details to understand your needs and recommend a suitable solution. When your project is being initiated, we share a detailed questionnaire, which helps our designers draft your initial concepts using the right understanding and tools. The concepts are then revised according to your feedback until they’re perfected and you're completely satisfied.",
  },
  {
    id: "06",
    question: " Do we use tools other than Canva?",
    answer:
      "Canva is used and loved by our designers, but for most use-cases, our designers use other tools that offer more features, flexibility, and attention to detail.",
  },
  {
    id: "07",
    question: "What best practices do we follow?",
    answer:
      " Our designers are adept at their craft and the use of best practices. The team is well versed in the intricate details of professional design. We also receive training and hold certifications in following endorsed guidelines and standards for ADA & WCAG compliance. ",
  },
];
